module.exports = __webpack_public_path__ + "img/nodata.e326f4bd.png";